import {useContext, useState} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useLocation} from '@s-ui/react-router'
import {SaitamaAd} from '@adv-mt/advertising-publift'

const baseClass = 'mt-AdvertisingRoadblock'
const googleSideClass = `${baseClass}-right1`

export default function AdvertisingRoadblock({children, isListing, isAdDetailPage}) {
  const {domain} = useContext(Context)
  const [isBrandDayEnabled, setIsBrandDayEnabled] = useState(false)
  const {pathname} = useLocation()

  const config = domain.get('config')
  const isMobile = config.get('isMobile')
  const {PubTop1, PubRight1, PubRight2, ADS_LIST_POSITIONS} = config.get('advertising')
  const pubTop1Id = ADS_LIST_POSITIONS?.[PubTop1]?.id
  const pubRight1Id = ADS_LIST_POSITIONS?.[PubRight1]?.id
  const pubRight2Id = ADS_LIST_POSITIONS?.[PubRight2]?.id

  const {ADS_LIST_FLATTENED_PATH_PATTERNS} = config.get('page')
  const isAdsListPath =
    !isAdDetailPage &&
    [
      ADS_LIST_FLATTENED_PATH_PATTERNS,
      '/renting/empresas/',
      '/segunda-mano-garantia' // Related tech-debt ticket: https://jira.ets.mpi-internal.com/browse/MTR-102005
    ]
      .flat()
      .some(route => {
        // Normalize route by removing trailing slash for consistent matching
        const cleanRoute = route?.endsWith('/') ? route.slice(0, -1) : route
        // Use includes(cleanRoute) because pathname may contain additional segments (e.g., /skoda/segunda-mano/palencia/)
        return pathname.includes(cleanRoute)
      })

  const isFullWidth = isAdsListPath

  const baseClassNames = cx(baseClass, {[`${baseClass}--fullWidth`]: isFullWidth})

  const handleIsBrandDayEnabled = displayDetails => {
    const [width, height] = displayDetails?.size || [0, 0]
    const isBrandDay = width === 300 && height === 1248
    setIsBrandDayEnabled(isBrandDay)
  }

  return (
    <div className={baseClassNames}>
      {!isMobile && (
        <div className={`${baseClass}-top`}>
          <SaitamaAd id={pubTop1Id} />
        </div>
      )}
      <div className={`${baseClass}-inner`}>{children}</div>
      {!isFullWidth && (
        <div className={`${baseClass}-fixed`}>
          <div
            className={cx(`${baseClass}-sideBanner`, googleSideClass, {
              'adit-RoadblockSideBanner--full-height': !isListing
            })}
          >
            <div
              className={cx(googleSideClass, {
                'mt-AdvertisingRoadblock-right1-brandDay': isBrandDayEnabled
              })}
            >
              <SaitamaAd
                id={pubRight1Id}
                onAdDisplayed={({displayDetails}) => handleIsBrandDayEnabled(displayDetails)}
              />
            </div>
          </div>
          <div className={`${baseClass}-right2-wrapper`}>
            <div className={`${baseClass}-right2`}>{isListing && <SaitamaAd id={pubRight2Id} />}</div>
          </div>
        </div>
      )}
    </div>
  )
}

AdvertisingRoadblock.displayName = 'AdvertisingRoadblock'

AdvertisingRoadblock.propTypes = {
  /**
   * Inner elements
   */
  children: PropTypes.node.isRequired,
  isListing: PropTypes.bool,
  isAdDetailPage: PropTypes.bool
}
